import React from "react";

const StoreIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M19.8266 6.05007L18.9565 2.85428C18.5942 1.52322 17.3781 0.59375 15.9985 0.59375H13.2333H6.71453H3.94886C2.56972 0.59375 1.3538 1.52322 0.991326 2.85418L0.121216 6.05007C-0.162335 7.09158 0.0568637 8.18877 0.723339 9.06078C1.44589 10.0058 2.61751 10.5709 3.85687 10.5709C5.07598 10.5709 6.15152 10.0261 6.8585 9.19358C7.63672 10.035 8.74 10.5709 9.97368 10.5709C11.2077 10.5709 12.311 10.035 13.0892 9.19358C13.7963 10.0261 14.8719 10.5709 16.0911 10.5709C17.3304 10.5709 18.5016 10.0068 19.224 9.06068C19.8905 8.18967 20.1102 7.09158 19.8266 6.05007Z"
      fill="inherit"
    />
    <path
      d="M17.953 11.5686C17.4021 11.5686 16.9553 12.0149 16.9553 12.5663V16.9459C16.9553 17.8316 16.2347 18.5526 15.3491 18.5526H13.9621V15.5595C13.9621 13.3584 12.1718 11.5686 9.97126 11.5686C7.77069 11.5686 5.98039 13.3584 5.98039 15.5595V18.5526H4.59386C3.70769 18.5526 2.98713 17.8316 2.98713 16.9459V12.5663C2.98713 12.0149 2.54036 11.5686 1.98942 11.5686C1.43848 11.5686 0.991699 12.0149 0.991699 12.5663V16.9459C0.991799 18.9327 2.6077 20.5481 4.59386 20.5481H15.3491C17.3352 20.5481 18.9507 18.9327 18.9507 16.9459V12.5663C18.9507 12.0149 18.5039 11.5686 17.953 11.5686Z"
      fill="inherit"
    />
  </svg>
);

export default StoreIcon;
